<template>
<p class="resultText">{{title}}</p>
  <div class="gridView">
    <div class="gridElement" v-for="element in posts" v-bind:key="element.id">
      <img v-if="element?.cover" :src="element?.cover" @click="method(element)"> <!-- Song -->
      <img v-else-if="element?.picture_medium" :src="element?.picture_medium" @click="method(element)"> <!-- Album Song -->
      <img v-else-if="element?.album?.cover_medium" :src="element?.album?.cover_medium" @click="method(element)"> <!-- Playlist Song -->
      <img class="noCover" v-else src="@/assets/foxbel-music-icon@2x.png">
      <p class="songTitle">{{element?.title}}</p>
      <p class="songTitle">{{element?.name}}</p>
    </div>
  </div>
</template>

<style scoped>

.topCard{
  width: 100%;
  height: 250px;
  margin: auto;
  background-color: #A70000B2;
  display: flex;
  color: white;
}

.description{
  text-align: start;
  margin-left: 30px;
  margin-top: 15px;
}

.buttonCont{
  margin-top: 90px;
  display: flex;
  gap: 20px;
}

.playButton{
  color: white;
  background-color: var(--mainred);
  height: 30px;
  width: 100px;
  border: 0px;
  border-radius: 15px;
  cursor: pointer;
}

.playButton:active{
  background-color: #e86060a5;
}

.resultText{
  text-align: start;
  font-size: 22px;
  font-weight: bold;
  color: var(--mainred)
}

.gridView{
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  row-gap: 12px;
  justify-items: center;
}

.gridElement{
  text-align: start;
  width: 160px;
}

.gridElement>img{
  width: 160px;
  height: 160px;
  object-fit: contain;
  cursor: pointer;
}

.songTitle{
  font-weight: bold;
  margin: 8px 0 0 0;
}

.songArtist{
  margin: 0;
}

.noCover{
  height: 100%;
  object-position: 10px 25px;
}

.dots{
  color: white;
  background-color: transparent;
  border: 0;
  font-size: 22px;
}

.icon{
  font-family: 'Font Awesome 6 Free';
  font-weight: 700;
}

/* @media screen
  and (max-width: 1500px){
  .gridView{
    grid-template-columns: repeat(6, 1fr);
  }
} */


</style>


<script>
export default {
    name:'GridDisplay',
    props:{
        title: String,
        posts: Array,
        method: Function,
    },
}
</script>